<template>
  <div class="mt-2">
    <div v-if="$vuetify.breakpoint.lg || $vuetify.breakpoint.md || $vuetify.breakpoint.xl">
      <!-- Tabs -->
      <v-tabs background-color="transparent" v-model="tabs" fixed-tabs>
        <v-tabs-slider color="#FAAD14"></v-tabs-slider>
        <v-row>
          <v-col></v-col>
          <v-tab key="0">{{ $t("shedulepage.upcomingm") }}</v-tab>
          <v-col></v-col>
          <v-tab key="1" :disabled="this.role == 'default'">{{
            $t("shedulepage.historym")
            }}</v-tab>
          <v-col></v-col>
        </v-row>
      </v-tabs>
      <!-- Tabs Items -->
      <v-tabs-items v-model="tabs">
        <!-- Tab 1 -->
        <v-tab-item key="0" class="mt-4">
          <v-container grid-list-md>
            <div class="text-center">
              <v-data-table :headers="headers" :items="scheduleData" :items-per-page="5" class="elevation-1">
                <template v-slot:[`item.date`]="{ item }">
                  {{ item.setting.startdate }} - {{ item.setting.enddate }}
                </template>
                <template v-slot:[`item.name`]="{ item }">
                  <td style="
                      display: inline-block;
                      word-wrap: break-word;
                      max-height: 3em;
                      overflow: hidden;
                      word-break: break-all;
                    ">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on" :title="item.roomname">
                          {{
                            item.roomname.length > 40
                              ? item.roomname.substring(0, 40) + "..."
                              : item.roomname
                          }}
                        </span>
                      </template>
                      <span>{{ item.roomname }}</span>
                    </v-tooltip>
                  </td>
                </template>
                <template v-slot:[`item.startmeeting`]="{ item }">
                  <v-row justify="center" align="center">
                    <v-btn v-if="item.status === 'Await' && chekjoin === false" depressed class="white--text buttonMC"
                      color="#66BB6A" @click="startschedule(item)">
                      <v-icon> mdi-video</v-icon>
                      {{ $t("button.btnstart") }}
                    </v-btn>
                    <v-btn v-if="item.status === 'Meeting'" depressed class="white--text buttonMC" color="#00BBAB"
                      @click="backtojoin(item.uid)">
                      <v-icon class="mr-2"> mdi-application-export</v-icon>
                      {{ $t("managepage.backrooms") }}
                    </v-btn>
                    <v-btn v-if="item.status === 'Not Time' && chekjoin === false" depressed @click="startschedule(item)"
                      class="white--text buttonMC" color="#FAAD14">
                      <v-icon class="mr-2"> mdi-timer-remove-outline</v-icon>
                      {{ $t("button.nottime") }}
                    </v-btn>
                    <v-btn v-if="item.status !== 'Meeting' && chekjoin === true" @click="Notrooms" depressed
                      class="white--text buttonMC" color="#78909C">
                      <v-icon class="mr-2"> mdi-calendar-remove-outline</v-icon>
                      {{ $t("button.openroom") }}
                    </v-btn>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div style="width: 18px;">
                          <v-icon
                            v-if="getSecondsUntilStart(item.setting.startdate) < 3600 && getSecondsUntilStart(item.setting.startdate) !== 0"
                            class="ml-2"
                            color="red"
                            size="18"
                            v-bind="attrs"
                            v-on="on"
                            >mdi-alert-circle-outline
                          </v-icon>
                        </div>
                      </template>
                      <span v-if="getSecondsUntilStart(item.setting.startdate) < 3600 && getSecondsUntilStart(item.setting.startdate) !== 0"
                        >การประชุมจะเริ่มในอีก {{ getCountdown(item.setting.startdate) }}
                      </span>
                    </v-tooltip>
                  </v-row>
                </template>
                <template v-slot:[`item.done`]="{ item }">
                  <v-row>
                    <v-col cols="2" md="3" sm="2" xs="2"></v-col>
                    <v-col cols="2" md="2" sm="2" xs="2">
                      <v-menu bottom offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-if="!item.done" v-bind="attrs" v-on="on" small fab dark color="#3D85C6"
                            style="border-radius: 5px">
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item @click="openModeleditroom(item)">
                            <v-icon class="mr-2 mt-1" color="#3D85C6">mdi-share-variant</v-icon>
                            {{ $t("shedulepage.share") }}
                          </v-list-item>
                          <v-list-item @click="openEditRoom(item)">
                            <v-icon class="mr-2 mt-1" color="#3D85C6">mdi-pencil</v-icon>
                            {{ $t("shedulepage.editroom") }}
                          </v-list-item>
                          <v-list-item @click="delescheduleroom(item)">
                            <v-icon class="mr-2 mt-1" color="#3D85C6">mdi-trash-can</v-icon>
                            {{ $t("shedulepage.delrroms") }}
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>
                  </v-row>
                </template>
              </v-data-table>
            </div>
          </v-container>
        </v-tab-item>
        <!-- Tab 2 -->
        <v-tab-item key="1" class="mt-4">
          <v-container grid-list-md>
            <div class="text-center">
              <v-data-table :headers="headersHistory" :items="historyData" :items-per-page="5"
                class="text-center elevation-1">
                <template v-slot:[`item.date`]="{ item }">
                  {{ item.start_date }} {{ item.start_time }} - {{ item.end_date }}
                  {{ item.end_time }}
                </template>
                <template v-slot:[`item.name`]="{ item }">
                  <td style="
                      display: inline-block;
                      word-wrap: break-word;
                      max-height: 3em;
                      overflow: hidden;
                      word-break: break-all;
                    ">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on" :title="item.room_name">
                          {{
                            item.room_name.length > 40
                              ? item.room_name.substring(0, 40) + "..."
                              : item.room_name
                          }}
                        </span>
                      </template>
                      <span>{{ item.room_name }}</span>
                    </v-tooltip>
                  </td>
                </template>
                <template v-slot:[`item.meeting_id`]="{ item }">
                  <v-menu v-if="item.length === 0">
                    <template v-slot:activator="{ on: menu, attrs }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltip }">
                          <v-icon style="color: #808080" class="ml-n4" v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                            mdi-file-document</v-icon>
                        </template>
                        <span>{{ $t("message.Noreport") }}</span>
                      </v-tooltip>
                    </template>
                  </v-menu>
                  <v-icon v-if="item.length !== 0" style="color: #086aab" class="ml-n4"
                    @click="openModalreport(item.meeting_id, item)">
                    mdi-file-document</v-icon>
                </template>
                <template v-slot:[`item.video_id`]="{ item }">
                  <v-icon v-if="item.record == true" style="color: #086aab" class="ml-n4"
                    @click="openModalvideo(item.meeting_id)">
                    mdi-motion-play-outline</v-icon>
                  <v-icon v-if="item.record == false" style="color: #dcdcdc" class="ml-n4">
                    mdi-motion-play-outline</v-icon>
                </template>
                <!-- <template v-slot:[`item.video_id`]="{ item }">
                  <v-icon
                  v-if="item.record == true"
                   style="color:#086AAB;"
                   class="ml-n4"
                   @click="openModalvideo(item.meeting_id)"
                   >
                    mdi-motion-play-outline</v-icon>
                    <v-menu >
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip bottom >
                      <template v-slot:activator="{ on: tooltip }">
                        <v-icon
                        v-if="item.record == false"
                          style="color:#DCDCDC;"
                          class="ml-n4"
                          v-bind="attrs"
                        v-on="{ ...tooltip, ...menu }"
                          >
                            mdi-motion-play-outline</v-icon>
                      </template>
                      <span>{{$t("shedulepage.norecording") }}</span>
                    </v-tooltip>
                  </template>
                </v-menu>
              </template> -->
              </v-data-table>
            </div>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <div v-if="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs" class="cardTable mt-2">
      <v-tabs background-color="transparent" v-model="tabs">
        <v-tabs-slider color="#FAAD14"></v-tabs-slider>
        <v-row>
          <!-- v-if="role === 'host' || 'user'" -->
          <v-tab key="0">{{ $t("shedulepage.upcomingm") }}</v-tab>
          <v-tab key="1" :disabled="this.role == 'default'">{{ $t("shedulepage.historym") }}
          </v-tab>
        </v-row>
      </v-tabs>
      <v-tabs-items v-model="tabs">
        <!-- v-if="role === 'host' || 'user'" -->
        <v-tab-item key="0" class="mt-4">
          <v-data-table :items-per-page="5" :headers="headers" :items="scheduleData" class="elevation-1">
            <template v-slot:[`item.date`]="{ item }">
              <!-- <td style="width: 10em;">
                        {{ item.setting.startdate }} - {{ item.setting.enddate }}
                     </td> -->
              <div style="display: flex">
                <td style="">
                  {{ item.setting.startdate }} - <br />{{ item.setting.enddate }}
                </td>
              </div>
            </template>
            <template v-slot:[`item.name`]="{ item }">
              <div style="display: flex">
                <td style="
                    display: inline-block;
                    word-wrap: break-word;
                    max-height: 3em;
                    overflow: hidden;
                    word-break: break-all;
                  ">
                  {{ item.roomname }}
                </td>
              </div>
            </template>
            <template v-slot:[`item.startmeeting`]="{ item }">
              <v-btn v-if="item.status === 'Await' && chekjoin === false" depressed class="white--text buttonMC"
                color="#66BB6A" @click="startschedule(item)">
                <v-icon> mdi-video</v-icon>
                {{ $t("button.btnstart") }}
              </v-btn>
              <v-btn v-if="item.status === 'Meeting'" depressed class="white--text buttonMC" color="#00BBAB"
                @click="backtojoin(item.uid)">
                <v-icon class="mr-2"> mdi-application-export</v-icon>
                {{ $t("managepage.backrooms") }}
              </v-btn>
              <v-btn v-if="item.status === 'Not Time' && chekjoin === false" depressed @click="startschedule(item)"
                class="white--text buttonMC" color="#FAAD14">
                <v-icon class="mr-2"> mdi-timer-remove-outline</v-icon>
                {{ $t("button.nottime") }}
              </v-btn>
              <v-btn v-if="item.status !== 'Meeting' && chekjoin === true" @click="Notrooms" depressed
                class="white--text buttonMC" color="#78909C">
                <v-icon class="mr-2"> mdi-calendar-remove-outline</v-icon>
                {{ $t("button.openroom") }}
              </v-btn>
            </template>
            <template v-slot:[`item.done`]="{ item }">
              <v-row>
                <v-col cols="2" md="3" sm="2" xs="2"></v-col>
                <v-col cols="2" md="2" sm="2" xs="2">
                  <v-menu bottom offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-if="!item.done" v-bind="attrs" v-on="on" small fab dark color="#3D85C6"
                        style="border-radius: 5px">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="openModeleditroom(item)">
                        <v-icon class="mr-2 mt-1" color="#3D85C6">mdi-share-variant</v-icon>
                        {{ $t("shedulepage.share") }}
                      </v-list-item>
                      <v-list-item @click="openEditRoom(item)">
                        <v-icon class="mr-2 mt-1" color="#3D85C6">mdi-pencil</v-icon>
                        {{ $t("shedulepage.editroom") }}
                      </v-list-item>
                      <v-list-item @click="delescheduleroom(item)">
                        <v-icon class="mr-2 mt-1" color="#3D85C6">mdi-trash-can</v-icon>
                        {{ $t("shedulepage.delrroms") }}
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item key="1" class="mt-4">
          <v-data-table :headers="headersHistory" :items="historyData" :items-per-page="5" class="text-center">
            <template v-slot:[`item.date`]="{ item }">
              {{ item.start_date }} {{ item.start_time }} - <br />{{ item.end_date }}
              {{ item.end_time }}
            </template>
            <template v-slot:[`item.name`]="{ item }">
              <div style="display: flex">
                <td style="
                    display: inline-block;
                    word-wrap: break-word;
                    max-height: 3em;
                    overflow: hidden;
                    word-break: break-all;
                  ">
                  {{ item.room_name }}
                </td>
              </div>
            </template>
            <template v-slot:[`item.meeting_id`]="{ item }">
              <v-menu v-if="item.length === 0">
                <template v-slot:activator="{ on: menu, attrs }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-icon style="color: #808080" class="ml-n4" v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                        mdi-file-document</v-icon>
                    </template>
                    <span>{{ $t("message.Noreport") }}</span>
                  </v-tooltip>
                </template>
              </v-menu>
              <v-icon v-if="item.length !== 0" style="color: #086aab" class="ml-n4"
                @click="openModalreport(item.meeting_id, item)">
                mdi-file-document</v-icon>
            </template>
            <template v-slot:[`item.video_id`]="{ item }">
              <v-icon v-if="item.record == true" style="color: #086aab" class="ml-n4"
                @click="openModalvideo(item.meeting_id)">
                mdi-motion-play-outline</v-icon>
              <v-icon v-if="item.record == false" style="color: #dcdcdc" class="ml-n4">
                mdi-motion-play-outline</v-icon>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <v-dialog v-model="downloadProgress" max-width="500px" scrollable>
      <v-card min-height="300px" style="border-radius: 10px" outlined color="#eeeeee">
        <br />
        <div class="text-center mt-12">
          <v-progress-circular rotate="-90" :size="80" color="primary" :width="10" :value="percentCompleted">{{
            percentCompleted }}</v-progress-circular>
          <p style="font-family: Sarabun; font-size: 24px; font-weight: 500" class="mt-5">
            {{ $t("loginpage.downloading") }}
          </p>
        </div>
      </v-card>
    </v-dialog>
    <dialoglinkcoppy />
    <editschedule />
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import editschedule from "../dialog/editschedule.vue";
import dialoglinkcoppy from "../dialog/dialoglinkcoppy.vue";
export default {
  components: {
    dialoglinkcoppy,
    editschedule,
  },
  data() {
    return {
      cid: "",
      txtLink: "",
      tabs: null,
      fileid: "",
      datetime: "",
      timestart: "",
      timeend: "",
      nameroomcoppy: "",
      chekjoin: false,
      stateLockRoom: false,
      dateInfo: "",
      dialoglink: false,
      dialog: false,
      scheduleData: [],
      jwt: require("jsonwebtoken"),
      historyData: [],
      schedule: "",
      snackbar: false,
      downloadProgress: false,
      percentCompleted: 0,
      role: "",
      countdowns: {},
    };
  },
  computed: {
    ...mapState("dialog", ["scheduleSetting", "editschedule", "historyload"]),
    headersHistory: {
      get() {
        return [
          {
            text: this.$t("table.datetime"),
            value: "date",
            align: "center",
            class: "my-header-style",
          },
          { text: this.$t("table.roomsname"), value: "name", align: "center" },
          {
            text: this.$t("table.reportrooms"),
            value: "meeting_id",
            align: "center",
          },
          {
            text: this.$t("table.videorecording"),
            value: "video_id",
            align: "center",
          },
        ];
      },
    },
    headers: {
      get() {
        return [
          {
            text: this.$t("table.datetime"),
            value: "date",
            align: "center",
            class: "my-header-style",
          },
          { text: this.$t("table.roomsname"), value: "name", align: "center" },
          {
            text: this.$t("table.statusrooms"),
            value: "startmeeting",
            align: "center",
          },
          {
            text: this.$t("table.settingmore"),
            value: "done",
            align: "center",
          },
        ];
      },
    },
  },
  created() {
    // this.history()
  },
  watch: {
    editschedule(value, oldValue) {
      if (value !== oldValue && value === false) {
        this.getschedule();
      }
    },
    historyload(value, oldValue) {
      if (value !== oldValue && value === false) {
        this.history();
      }
    },
    scheduleSetting(value, oldValue) {
      if (value !== oldValue && value === false) {
        this.getschedule();
      }
    },
  },
  mounted() {
    if (this.$route.query.tabs === "1") {
      this.tabs = 1;
    }
    this.history();
    this.getschedule();
    this.decodejwttoken();
    const vm = this;
    this.intervalTime = setInterval(() => {
      vm.getschedule();
      this.refrestoken();
    }, 30000);
    this.countdownInterval = setInterval(() => {
      this.updateCountdowns();
    }, 1000);
  },
  methods: {
      parseCustomDate(dateStr) {
        // Expects dd/mm/yyyy HH:mm
        if (!dateStr) return null;
        const [datePart, timePart] = dateStr.split(' ');
        if (!datePart || !timePart) return null;
        const [day, month, year] = datePart.split('/').map(Number);
        const [hour, minute] = timePart.split(':').map(Number);
        return new Date(year, month - 1, day, hour, minute);
      },
      getSecondsUntilStart(startdate) {
        // console.log('startdate', startdate)
        if (!startdate) return 0;
        const start = this.parseCustomDate(startdate);
        if (!start) return 0;
        const now = new Date();
        const diffMs = start - now;
        const diffSec = Math.max(Math.floor(diffMs / 1000), 0);
        return diffSec;
      },
      getTimeUntilStart(startdate) {
        if (!startdate) return '00:00 นาที';
        const start = this.parseCustomDate(startdate);
        if (!start) return '00:00 นาที';
        const now = new Date();
        let diffMs = start - now;
        if (diffMs < 0) diffMs = 0;
        const totalSeconds = Math.floor(diffMs / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} นาที`;
      },
      updateCountdowns() {
        // Update countdowns for each meeting
        if (!this.scheduleData) return;
        this.scheduleData.forEach(item => {
          if (item && item.setting && item.setting.startdate) {
            this.$set(this.countdowns, item.setting.startdate, this.getTimeUntilStart(item.setting.startdate));
          }
        });
      },
      getCountdown(startdate) {
        // Get the current countdown value for a meeting
        return this.countdowns[startdate] || this.getTimeUntilStart(startdate);
      },
    ...mapActions("dialog", [
      "setDialogScheduleSetting",
      "setDialogdataedit",
      "setdatahistory",
      "setMeetingIdReport",
      "setIdReportvote",
      "setdialogvideo",
      "setDialogcoppylink",
      "setDialogdatacoppylink",
    ]),
    openEditRoom(item) {
      // console.log('item', item)
      if (item.started === false) {
        this.setDialogdataedit(item);
        this.setDialogScheduleSetting(true);
      } else {
        this.$swal(this.$t("message.closmeetingandopen"), this.$t(""), "warning");
      }
    },
    openModeleditroom(item) {
      // console.log('item', item)
      this.setDialogcoppylink(true);
      this.setDialogdatacoppylink(item);
    },
    startschedule(item) {
      // console.log('meeting_id', meeting_id)
      this.hostgetlobby(item);
    },
    Notrooms() {
      this.$swal(
        this.$t("message.newmeeting"),
        this.$t("message.closemeeting"),
        "warning"
      );
    },
    backtojoin(uuid) {
      // console.log('blackroom', uuid)
      this.$router.push(`/backtolobbyHost?uuid=${uuid}`);
    },
    checkjoin() {
      this.axios
        .get(process.env.VUE_APP_API + "/api/lv1/join/checksession")
        .then((res) => {
          // console.log('checkjoin', res)
          if (res.data.result === "Success") {
            // console.log('checksession', res.data.data)
            this.blackroom = res.data.data.uid;
            this.chekjoin = res.data.data.session;
            // if(this.chekjoin === true) {

            // }
          }
        })
        .catch((err) => {
          console.log("opentobacklooby", err);
        });
      // this.$router.push({ path: '/backtolobbyHost' + '/?uuid=' + this.uuid, params: { schedule: 1 } }).catch(() => {})
    },
    hostgetlobby(data) {
      // this.$router.push({ name: 'Lobby', params: { schedule: 1 } })
      this.$router.push({ name: "Lobby", params: { schedule: 2 } }).catch(() => { });
      // this.$router.push('/lobby')
      this.setDialogdataedit(data);
    },
    openModalvideo(item) {
      // console.log(item)
      // this.fileid = item
      this.setdialogvideo(item);
      this.$router.push("/downloadvideo");
    },
    decodejwttoken() {
      var token = localStorage.getItem("user-token");
      const decryptedText = this.CryptoJS.AES.decrypt(
        token,
        process.env.VUE_APP_SECRET_KEY
      )
        .toString(this.CryptoJS.enc.Utf8)
        .replace(/"/g, "");
      var data = this.jwt.decode(decryptedText);
      this.userData = data;
      this.role = this.userData.user.role;
    },
    async refrestoken() {
      var token = localStorage.getItem("user-token");
      await this.axios
        .get(
          process.env.VUE_APP_API + "/api/lv1/auth/refreshtoken",
          {
            headers: {
              Authorization: "bearer " + localStorage.getItem("user-token"),
            },
          }
          // await this.axios.post(process.env.VUE_APP_API + '/api/v1/authentication/refrestoken', {
          //   headers: {
          //         Authorization: 'bearer ' + token
          //       }
          // }
        )
        .then((res) => {
          // console.log('sssss', res)
        })
        .catch((err) => {
          this.$swal(this.$t("message.Sessiontimeout"), "", "warning").then((result) => {
            localStorage.clear();
            localStorage.setItem("lang", "th");
            window.open("/", "_self");
          });
        });
    },
    decodeJS(data) {
      try {
        var bytes = this.CryptoJS.AES.decrypt(data, process.env.VUE_APP_SECRET_KEY);
        var decryptedData = JSON.parse(bytes.toString(this.CryptoJS.enc.Utf8));
        return decryptedData;
      } catch (error) {
        console.log(">>>>>>>>", error);
        return error;
      }
    },
    getschedule() {
      this.axios
        .get(process.env.VUE_APP_API + "/api/lv1/room/schedule")
        .then((res) => {
          // console.log('res', res)
          if (res.data.data.room_count > 0) {
            this.schedule = JSON.parse(this.decodeJS(res.data.data.room_data));
            // console.log('data', this.schedule)
            this.scheduleData = this.schedule;
            // console.log('getschedule', this.scheduleData)
            this.$store.dispatch('dialog/setDataRoomSchedule', this.scheduleData)
            this.checkjoin();
          } else {
            this.scheduleData = [];
            this.$store.dispatch('dialog/setDataRoomSchedule', [])
          }
        })
        .catch((err) => {
          console.log("getschedule : ", err);
        });
    },
    delescheduleroom(item) {
      // console.log('item', item)
      if (item.started === false) {
        this.$swal
          .fire({
            title: this.$t("message.delrooms"),
            text: "",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3D85C6",
            confirmButtonText: this.$t("button.btnok"),
            cancelButtonColor: "#D63A3A",
            cancelButtonText: this.$t("button.btncancel"),
          })
          .then((res) => {
            if (res.isConfirmed === true) {
              this.axios
                .delete(
                  process.env.VUE_APP_API + "/api/lv1/room/delete/" + item.meeting_id
                )
                .then((result) => {
                  // console.log('sssssssss', result)
                  this.$swal(
                    this.$t("message.del"),
                    this.$t("message.delroomsucces"),
                    "success"
                  );
                  this.getschedule();
                });
            } else {
              // console.log("Cancel");
            }
          });
      } else {
        this.$swal(this.$t("message.closemeeting"), this.$t(""), "warning");
      }
    },
    async history() {
      try {
        const { data: resData } = await this.axios.get(
          process.env.VUE_APP_API + "/api/lv1/report/reports",
          {
            headers: {
              Authorization: "bearer " + localStorage.getItem("user-token"),
            },
          }
        );
        if (resData.result === "Success") {
          // console.log('new resData', resData)
          if (resData.data === null || resData.data === "") {
            // console.log('Can not Data')
          } else {
            var historyA = JSON.parse(this.decodeJS(resData.data));
            this.historyData = historyA.history;
            // console.log('new historyData', this.historyData)
          }
        }
      } catch (error) {
        console.error("errorhistory", error);
      }
      // try {
      //   const { data: resData } = await this.axios.get(process.env.VUE_APP_API + '/api/v1/history')
      //   this.historyData = resData.history
      //   console.log('historyData', this.historyData)
      // } catch (error) {
      //   console.error('errorhistory', error)
      // }
    },
    openModalreport(meeting_id, item) {
      // console.log('setdatahistory', item)
      this.setdatahistory(item);
      this.$router.push("/reporthistory");
    },
  },
};
</script>
<style scoped>
.cardTable {
  background-color: #f3f3f3;
  padding: 20px;
}
</style>
